var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96 11.882a3.06 3.06 0 000 6.118 3.06 3.06 0 000-6.118zM1.03 5.685c-.35 0-.692.016-1.033.046v1.794a9.9 9.9 0 0110.924 9.841c0 .214 0 .424-.02.634h1.792c0-.21.016-.423.016-.633A11.695 11.695 0 001.03 5.685z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03 0C.682 0 .328 0 0 .033v1.79a13.24 13.24 0 011.033-.035 15.592 15.592 0 0115.573 15.579V18h1.765v-.633A17.387 17.387 0 001.03 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/Signal.48b7a299.svg";
export { ForwardRef as ReactComponent };